<template lang="pug">
    div
        v-dialog.dialogEdit(v-model="show"
            width="680")
            v-card.dialogEdit
                v-card-text.pb-0
                v-container
                    div.gr-loader-snipper--wrapper(v-if="loading")
                        span.gr-loader-snipper
                    v-row#headerModalEdit.pt-3
                        v-col(cols="10")
                            span(v-if="!isGenericEntity") #[translate Restaurant data]
                            span(v-else) Datos del negocio
                        v-col.mt-5(cols="2")
                            img.close-modal.cursor-pointer(:src="imgClose" @click.stop="show=false")
                    v-row#bodyModalEdit
                        v-col(cols="12")
                            v-container
                                v-row
                                    v-col.text-left.pt-6.pb-4(cols="12" v-if="!saveStatus")
                                        div.messageError
                                            span {{ messageError ? messageError : $gettext('An error occurred while recording.') }}
                                    v-col.text-left.pt-6.pb-0(cols="6")
                                        span(v-if="!isGenericEntity") #[translate Name of the restaurant]
                                        span(v-else) Nombre del negocio
                                        input.inputFullEditModal(type="text" v-model="data.name")
                                    v-col.text-left.pt-6.pb-0(cols="6")
                                        span #[translate Full address]
                                        input.inputFullEditModal(type="text" v-model="data.street_address")
                                    v-col.text-left.pb-0(cols="6")
                                        span #[translate Postal code]
                                        input.inputFullEditModal(type="text" v-model="data.postal_code")
                                    v-col.text-left.pb-0(cols="6")
                                        span #[translate City]
                                        input.inputFullEditModal(type="text" v-model="data.province")
                                    v-col.text-left.pb-0(cols="6")
                                        span #[translate Telephone]
                                        input.inputFullEditModal(type="text" v-model="data.phone")
                                    v-col.text-left.pb-0(cols="6" v-if="false")
                                        span #[translate Fax number]
                                        input.inputFullEditModal(type="text" v-model="data.fax")
                                    v-col.text-left.pb-0(cols="6")
                                        span #[translate Email]
                                        input.inputFullEditModal(type="email" v-model="data.email")
                                    v-col.text-left.pb-0(cols="12")
                                        span #[translate Website]
                                        input.inputFullEditModal(type="text" v-model="data.url")
                                    v-col#autocompleteCategories.text-left.pb-10(cols="6")
                                        span #[translate Bussiness category]
                                        v-autocomplete(
                                        dense
                                        :items="customCategories"
                                        v-model="googlePrimaryCategoryCustom"
                                        return-object
                                        )
                                    v-col.text-left.pb-10(cols="6")
                                        span #[translate Price range]
                                        select.selectFullEditModal(v-if="data.price_range" v-model="data.price_range")
                                            option(v-for="price in priceRange" :value="price") {{ price.value }}
                    v-row#footerModalEdit
                        v-col(cols="12")
                            button.btnCancelEditModal(@click.stop="show=false") #[translate Cancel]
                            button.btnSaveEditModal(@click="save()")  #[translate Save]
</template>
<script>
import commonMixins from '@/mixins/common.js'
import SrvLocal from '@/services/local.js'

export default {
    mixins: [commonMixins],
    props: ['visible','idBussines'],
    data(){
        return {
            loading: false,
            imgClose: require('@/assets/img/ico-close-edit.svg'),
            data: {},
            categories: [],
            priceRange: [],
            customCategories: [],
            googlePrimaryCategoryCustom: {},
            section: 'data-restaurant',
            saveStatus: true,
            messageError: null
        }
    },
    watch: {
        visible (newValue){
            if (newValue) {
                this.data = {}
                this.loadData()
            }
        }
    },
    computed: {
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                this.$emit('close')
                }
            }
        },
        showPriceRange () {
            return this.priceRange.length > 0 ? true : false
        }
    },
    methods: {
        async loadData () {
            //CARGAMOS DATOS
            this.loading = true
            await SrvLocal.getLocalMarketingBusinessCategory()
            .then(res => {
                if (res.status === 200) {
                    this.categories = res.data
                    this.customCategories = res.data.map((cat) => {
                        return {text: cat.name, value: cat.id, categoryId: cat.categoryId}
                    })
                }
            }, () => {
            })
            await SrvLocal.getLocalMarketingPriceRange()
            .then(res => {
                if (res.status === 200) {
                    this.priceRange = res.data.results
                }
            }, () => {
            })
            await SrvLocal.getLocalMarketing(this.section)
            .then(res => {
                if (res.status === 200) {
                    this.data = res.data
                    this.googlePrimaryCategoryCustom = {text: this.data.googlePrimaryCategory ? this.data.googlePrimaryCategory.name : null, 
                        value: this.data.googlePrimaryCategory ? this.data.googlePrimaryCategory.id : null, 
                        categoryId: this.data.googlePrimaryCategory ? this.data.googlePrimaryCategory.categoryId : null}
                    this.loading = false
                }
            }, () => {
            })
        },
        async save () {
            this.data.googlePrimaryCategory = this.googlePrimaryCategoryCustom.value
            if (this.data.price_range) {
                this.data.price_range = this.data.price_range.id
            }
            this.loading = true
            await SrvLocal.setLocalMarketing(this.section, this.data)
            .then(res => {
                if (res.status !== 200) {
                    this.saveStatus = false
                }
            }, () => {
            })
            if (this.saveStatus) {
                const res = await SrvLocal.syncBunsiness(this.idBussines, 'only_basic_info')
                if (Object.keys(res.data).includes('success') && !res.data.success) {
                    this.saveStatus = false
                    this.messageError = res.data.error.message
                } else {
                    this.show = false
                    this.$emit('refreshSync')
                }
            }
            this.loading = false
        }
    }
}
</script>
<style lang="scss" scoped>
    #autocompleteCategories{
        background-color: #fff;
        input{
            font-size: 0.875rem !important;
        }
    }
    .theme--light.v-text-field--solo-inverted.v-input--is-focused>.v-input__control>.v-input__slot {
        background-color: #fff;
    }
    .messageError{
        background-color: #F5B1B8;
        border: 1px solid #F93549;
        color: #F93549;
        padding:15px;
    }
</style>
